var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 16" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M12.5 10h2v2h-2zM8.5 10h2v2h-2zM4.5 10h2v2h-2zM12.5 7h2v2h-2zM8.5 7h2v2h-2zM4.5 7h2v2h-2zM3.8.3h2.3v2.9H3.8zM12.9.3h2.3v2.9h-2.3z" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M16.1 3v1.1H12V3H7v1.1H2.9V3H0v12.8h19V3h-2.9zm.7 10.7H2.2V5.2h14.6v8.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Calendar.svg